/**
 * Catálogo de módulos do menu do tenant.
 * O superadmin liga/desliga por empresa. O papel do usuário continua limitando o que cada pessoa vê.
 * Sem chave gravada, vale `padrao` (o que o sistema já mostrava). Módulos novos nascem desligados.
 */
export const MENU_MODULOS = [
  {
    id: 'documentos',
    label: 'Documentos',
    grupo: 'Operação',
    descricao: 'Documentos da empresa.',
    padrao: true,
    rotas: ['/app/documents', '/app/fornecedor-documentos', '/app/documentos-obrigatorios']
  },
  {
    id: 'recebimentos',
    label: 'Recebimentos',
    grupo: 'Operação',
    descricao: 'Entrada de matérias-primas e conferência.',
    padrao: true,
    rotas: ['/app/receivings']
  },
  {
    id: 'operacao_armazem',
    label: 'Operação de armazém',
    grupo: 'Operação',
    descricao: 'Leitura de QR do pallet e da posição, dentro de Recebimentos.',
    padrao: true,
    requer: 'armazenamento',
    rotas: ['/app/armazem-operacao']
  },
  {
    id: 'setores',
    label: 'Setores',
    grupo: 'Cadastros',
    descricao: 'Setores da planta.',
    padrao: true,
    rotas: ['/app/setores']
  },
  {
    id: 'equipamentos',
    label: 'Equipamentos',
    grupo: 'Cadastros',
    descricao: 'Cadastro, painel, plano de manutenção e cotações de equipamentos.',
    padrao: true,
    rotas: ['/app/equipamentos', '/app/plano-manutencao', '/app/fornecedor-equipamentos']
  },
  {
    id: 'fornecedores',
    label: 'Fornecedores',
    grupo: 'Cadastros',
    descricao: 'Fornecedores por tipo de catálogo.',
    padrao: true,
    rotas: ['/app/suppliers', '/app/fornecedores']
  },
  {
    id: 'insumos',
    label: 'Insumos',
    grupo: 'Cadastros',
    descricao: 'Ingredientes, embalagens, serviços e limpeza.',
    padrao: true,
    rotas: ['/app/products', '/app/insumos']
  },
  {
    id: 'produtos',
    label: 'Produtos',
    grupo: 'Cadastros',
    descricao: 'Produtos finais.',
    padrao: true,
    rotas: ['/app/produtos-finais']
  },
  {
    id: 'estoque',
    label: 'Estoque',
    grupo: 'Operação',
    descricao: 'Saldo de matérias-primas, insumos e ingredientes.',
    padrao: true,
    rotas: ['/app/estoque']
  },
  {
    id: 'armazenamento',
    label: 'Armazenamento',
    grupo: 'Operação',
    descricao: 'Câmaras, ruas, estantes e posições. Fica dentro de Estoque.',
    padrao: true,
    requer: 'estoque',
    rotas: ['/app/armazenamento']
  },
  {
    id: 'rastreabilidade',
    label: 'Rastreabilidade',
    grupo: 'Operação',
    descricao: 'Histórico de rota das matérias-primas, insumos e ingredientes.',
    padrao: true,
    rotas: ['/app/rastreabilidade']
  },
  {
    id: 'compras',
    label: 'Compras',
    grupo: 'Operação',
    descricao: 'Cotações de compra.',
    padrao: true,
    rotas: ['/app/cotacoes']
  },
  {
    id: 'marketplace',
    label: 'Marketplace',
    grupo: 'Operação',
    descricao: 'Marketplace de fornecedores.',
    padrao: true,
    rotas: ['/app/marketplace', '/app/propostas']
  },
  {
    id: 'producao',
    label: 'Produção',
    grupo: 'Produção',
    descricao: 'Planejamento, ordens, pesagem, fluxo, relatórios e não conformidades.',
    padrao: true,
    rotas: [
      '/app/producao',
      '/app/planejamento-producao',
      '/app/separacao-pesagem',
      '/app/fluxo-setorial',
      '/app/relatorios-producao',
      '/app/nao-conformidades-producao',
      '/app/trabalho',
      '/app/kiosk'
    ]
  },
  {
    id: 'monitoramento',
    label: 'Monitoramento',
    grupo: 'BPF',
    descricao: 'POP: água, limpeza, manutenção, pragas, temperatura, hábitos e certificados.',
    padrao: false,
    rotas: ['/app/monitoramento']
  },
  {
    id: 'expedicao',
    label: 'Expedição',
    grupo: 'BPF',
    descricao: 'Registro de saídas de produto acabado.',
    padrao: false,
    rotas: ['/app/expedicao']
  },
  {
    id: 'usuarios',
    label: 'Usuários',
    grupo: 'Gestão',
    descricao: 'Usuários da empresa.',
    padrao: true,
    rotas: ['/app/users']
  },
  {
    id: 'relatorios',
    label: 'Relatórios',
    grupo: 'Gestão',
    descricao: 'Relatórios gerais.',
    padrao: true,
    rotas: ['/app/reports']
  },
  {
    id: 'configuracoes',
    label: 'Configurações',
    grupo: 'Gestão',
    descricao: 'Configurações da conta.',
    padrao: true,
    rotas: ['/app/settings']
  },
  {
    id: 'parametros',
    label: 'Parâmetros',
    grupo: 'Cadastros',
    descricao: 'Categorias de insumos e tipos de equipamentos.',
    padrao: true,
    rotas: ['/app/parametros']
  }
];

const POR_ID = Object.fromEntries(MENU_MODULOS.map((m) => [m.id, m]));

export function moduloAtivo(modulos, id) {
  const def = POR_ID[id];
  if (!def) return true;
  const mapa = modulos && typeof modulos === 'object' ? modulos : {};
  const ligado = Object.prototype.hasOwnProperty.call(mapa, id) ? mapa[id] === true : def.padrao !== false;
  if (!ligado) return false;
  if (def.requer && !moduloAtivo(mapa, def.requer)) return false;
  return true;
}

export function modulosIniciais(empresa) {
  const gravado = empresa?.modulos && typeof empresa.modulos === 'object' ? empresa.modulos : {};
  const out = {};
  for (const item of MENU_MODULOS) {
    if (Object.prototype.hasOwnProperty.call(gravado, item.id)) {
      out[item.id] = gravado[item.id] === true;
    } else if (item.id === 'armazenamento' && empresa && empresa.modulo_armazenamento === false) {
      out[item.id] = false;
    } else if (item.id === 'operacao_armazem' && empresa && empresa.modulo_armazenamento === false) {
      out[item.id] = false;
    } else {
      out[item.id] = item.padrao !== false;
    }
  }
  if (out.armazenamento !== true) out.operacao_armazem = false;
  if (out.estoque !== true) out.armazenamento = false;
  return out;
}

export function moduloDaRota(pathname) {
  const path = String(pathname || '');
  if (!path.startsWith('/app') || path.startsWith('/app/dashboard') || path.startsWith('/app/login')) {
    return null;
  }
  const ordenado = [...MENU_MODULOS].sort(
    (a, b) => Math.max(...b.rotas.map((r) => r.length)) - Math.max(...a.rotas.map((r) => r.length))
  );
  for (const item of ordenado) {
    if (item.rotas.some((rota) => path === rota || path.startsWith(`${rota}/`))) return item.id;
  }
  return null;
}

export function filtrarMenu(items, modulos) {
  if (!Array.isArray(items)) return [];
  const saida = [];
  for (const item of items) {
    if (item.modulo && !moduloAtivo(modulos, item.modulo)) continue;
    if (Array.isArray(item.submenu)) {
      const submenu = filtrarMenu(item.submenu, modulos);
      if (submenu.length === 0) continue;
      saida.push({ ...item, submenu });
      continue;
    }
    saida.push(item);
  }
  return saida;
}
